import * as React from 'react';

import {FeatureGateModalWrapper} from './feature-gate-modal-wrapper';

type Props = {
    isOpen: boolean;
    onClose: () => void;
};

export function SchedulerFeatureGate(props: Props) {
    const {isOpen, onClose} = props;

    return (
        <FeatureGateModalWrapper
            title='Book and manage meetings with leads and customers '
            description='Nutshell Scheduler allows you to plan, schedule and manage meetings with prospects and clients, all from inside Nutshell.'
            bullets={[
                'Collect bookings via shared link or web form.',
                'Include Zoom, Google Meet, or Microsoft Teams links in the invitation.',
                'Gather information about attendees with a Nutshell form.',
                'Automatically create new leads with each booking.',
            ]}
            feature='scheduler'
            isOpen={isOpen}
            onClose={onClose}
        />
    );
}
